Auth = require 'db/auth'
_ = require 'underscore'
{ initialize } = require('ldclient-js')

initialUserOpts = {
  key: Auth.myId(),
  anonymous: !Auth.isLoggedIn(),
}

class LaunchDarklyClient
  constructor: (userOpts = {}, bootstrap = 'localStorage') ->
    @user = _.extend userOpts, initialUserOpts
    @client = initialize window.launchdarklyKey,
      @user,
      { bootstrap }

    for method, func of @client
      @[method] = func

  updateUserInfo: ->
    @user = _.extend {
      custom: {
        channel: Auth.me().get('channels')?.active,
        idOrgs: Auth.me()?.get('idOrganizations') ? []
        orgs: ['[Redacted]']
      }
    }, @user

    @identify @user

module.exports = new LaunchDarklyClient()



// WEBPACK FOOTER //
// ./app/scripts/lib/ldclient.coffee